export default __webpack_public_path__ + "static/media/Linkedin.89e2bfd7.svg";